export default function vehicleMileage() {

    $(function() {
        let wrapper = $('.vehicle-mileage-element-wrapper');
        if (wrapper.length > 0) {
            wrapper.each(function(e){
                let element = $(this);
                let button = element.find('button.calculate-total-button');
                let includeBaseRate = element.find('input.include-base-rate');
                let includeBaseRateBtn = element.find('.include-base-rate-btn');
                let text = element.find('input.calculate-total-text');
                let amount = element.find('input.calculate-total-amount');
                let total = element.find('input.calculate-total-total');

                button.on('click',function (f){
                    f.preventDefault();
                    CalculateTotal();
                    return false;
                });

                includeBaseRate.on('change',function (g){
                    if($(this).is(':checked')){
                        includeBaseRateBtn.addClass('alternate-button');
                    } else {
                        includeBaseRateBtn.removeClass('alternate-button');
                    }
                    if(amount.val() !== ''){
                        CalculateTotal();
                    }
                });

                text.on('change',function (h){
                    amount.val('');
                    total.val('');
                });


                function CalculateTotal(){
                    if(parseInt(text.val()) > -1){
                        $.ajax({
                            url: '/VehicleMileageCallback?mileage='+text.val(),
                            type: 'GET',
                            success: function success(response) {
                                let data = JSON.parse(response);
                                if(parseFloat(data.Total) > 0){
                                    if(includeBaseRate.is(':checked')){
                                        amount.val(data.Amount);
                                        total.val(data.Total);
                                    } else {
                                        amount.val(data.Amount);
                                        total.val(data.Amount);
                                    }

                                } else {
                                    amount.val('0.00');
                                    total.val('0.00');
                                }

                            },
                            error: function error() {

                            }
                        });
                    } else {
                        amount.val('');
                        total.val('');
                    }
                }
            });
        }
    });
}
